import React from 'react'
import { Modal } from '@components/ui'

type ChartingDiscardPlanChangesModalProps = {
  show: boolean
  planName: string
  onDismiss: () => void
  onSaveChanges: () => void
  onDiscard: () => void
}

const ChartingDiscardPlanChangesModal: React.FC<
  ChartingDiscardPlanChangesModalProps
> = ({ show, planName, onDismiss, onSaveChanges, onDiscard }) => {
  const name = planName.trim() || 'this plan'

  return (
    <Modal
      open={show}
      onClose={onDismiss}
      size="xs"
      title="Discard changes"
      description={`Are you sure you want to discard unsaved changes to "${name}"?`}
      primaryLabel="Discard"
      secondaryLabel="Save changes"
      primaryDestructive
      onPrimaryClick={onDiscard}
      onSecondaryClick={onSaveChanges}
    />
  )
}

export default ChartingDiscardPlanChangesModal
